import React, { Component } from 'react'

import Icon from '@f/elements/Icon'

class FullscreenGallery extends Component {
  async componentDidMount() {
    const { default: Glide } = await import(
      /*
        webpackChunkName: "Glide",
        webpackMode: "lazy"
      */
      '@glidejs/glide'
    )

    // Initialise Glide
    this.glide = new Glide(this.glideRef, {
      type: 'carousel',
      startAt: this.props.initialIndex,
      perView: 1,
      dragThreshold: 60,
      swipeThreshold: 20
    })

    let wrapper = document.querySelector('.gallery-wrapper')
    if (wrapper) {
      // Determine if user has dragged (let glide.js change slide) or clicked (close gallery)
      let closeModal = this.props.closeModal
      let isDrag = false
      let cursorPosBefore = 0
      wrapper.addEventListener('mousedown', event => {
        isDrag = false
        cursorPosBefore = event.screenX
      })
      wrapper.addEventListener('mousemove', event => {
        let cursorPosAfter = event.screenX
        isDrag = Math.abs(cursorPosBefore - cursorPosAfter) > 20
      })
      wrapper.addEventListener('mouseup', () => {
        if (!isDrag) {
          closeModal()
        } else {
          return
        }
      })
    }

    this.glide.mount()
  }

  render() {
    return (
      <div
        className='[ f-c-ba-bla ] fullscreen-gallery-outer-container'
        onClick={this.props.closeModal}>
        <div className='glide' ref={ref => (this.glideRef = ref)}>
          <div
            className='fullscreen-gallery-container glide__track'
            data-glide-el='track'>
            <div className='[ f-c-ba-bla ] gallery-wrapper glide__slides'>
              {this.props.slides.map((slide, index) => {
                return (
                  <div
                    key={`slide-${index}`}
                    className='gallery-slide glide__slide'>
                    <img
                      className='gallery-slide-image'
                      src={slide}
                      loading='lazy'
                    />
                  </div>
                )
              })}
            </div>
            {this.props.slides.length > 1 && (
              <div data-glide-el='controls' className='glide__arrows'>
                <button
                  data-glide-dir='<'
                  onClick={event => event.stopPropagation()}
                  className='gallery-left glide__arrow glide__arrow--left'>
                  <Icon
                    icon='left-arrow-16px'
                    className='[ f-icon-030 f-c-st-whi ]'
                  />
                  <span className='[ f-visually-hidden ]'>Vorheriges Bild</span>
                </button>
                <button
                  data-glide-dir='>'
                  onClick={event => event.stopPropagation()}
                  className='gallery-right glide__arrow glide__arrow--right'>
                  <Icon
                    icon='right-arrow-16px'
                    className='[ f-icon-030 f-c-st-whi ]'
                  />
                  <span className='[ f-visually-hidden ]'>Nächstes Bild</span>
                </button>
              </div>
            )}
          </div>
          <button
            onClick={this.props.closeModal}
            className='fullscreen-gallery-close'>
            <div className='close-gallery-icon' />
          </button>
        </div>
      </div>
    )
  }
}

export default FullscreenGallery
